import { useRouter } from 'next/router'

export const usePathname = () => {
  const router = useRouter()
  // for some reason, pathname is undefined when the page is not mounted,
  // even though typescript says it's a string
  return router.pathname as string | null
}
